import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const RouteGuard = ({ children, type, permission }) => {
    const token = localStorage.getItem("token");
    const permissions = useSelector(state => state.permission.rolePermissions) || [];

    if (type === "login") {
        if (token) {
            return <Navigate to="/dashboard" replace />;
        }
        return children;
    }

    if (type === "auth") {
        if (!token) {
            return <Navigate to="/" replace />;
        }
        return children;
    }

    if (type === "protected") {
        if (!token) return <Navigate to="/" replace />;
        if (permission && !permissions.includes(permission)) {
            return <Navigate to="/no-permission" replace />;
        }

        return children;
    }

    return children;
};

export default RouteGuard;
